<ng-container *ngFor="let error of errors">
  <ng-container *ngIf="showError(error)">
    <small class="text-danger">
      {{ getMessage(error) | translate }}
    </small>
  </ng-container>
</ng-container>
